__webpack_require__.p = "/Aura_Jewelry_Store.2025/";